<template>
  <div
    :class="[
      $style.vgp_label,
      $style.vgp_label_slot_root,
      $style[`vgp_label_title_${titleSize}`],
      isError ? $style.vgp_label_error : null
    ]"
  >
    <div :class="$style.vgp_label_header">
      <sprite
        v-if="icon"
        :class="$style.icon"
        :color="iconColor"
        :name="iconName"
        :type="iconType"
        :size="iconSize"
      />

      <span
        v-if="label"
        :class="[$style.vgp_label_text, $style.vgp_label_text_slot, $style.elipsis_text]"
      >
        {{ label }}
        <span
          v-if="labelAsterix"
          :class="$style.vgp_label_asterisk"
        >*</span>
      </span>
      <span
        v-if="action"
        :class="$style.vgp_label_action"
        role="button"
        tabindex="0"
        :aria-label="action"
        :style="actionStyle ? actionStyle : {}"
        @click="onClickAction"
        @keydown.enter.prevent="onClickAction"
        @keydown.space.prevent="onClickAction"
      >
        {{ action }}
      </span>
    </div>
    <div :class="$style.vgp_label_slot">
      <slot name="body" />
    </div>
    <div
      v-if="description"
      :class="$style.vgp_label_description"
    >
      {{ description }}
    </div>
  </div>
</template>

<script>
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  name: 'VgpLabelSlot',
  components: {
    sprite,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: 'Text',
    },
    labelAsterix: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: Object, // { name, type, size }
      required: false,
      default: null,
    },
    action: {
      type: String,
      required: false,
      default: null,
    },
    actionStyle: {
      type: Object,
      required: false,
      default: null,
    },
    titleSize: {
      type: String,
      default: 'small',
      validator: val => ['small', 'large'].includes(val),
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    onClickAction: null,
  },
  computed: {
    iconName() {
      return this.icon?.name || 'check';
    },
    iconType() {
      return this.icon?.type || 'regular';
    },
    iconSize() {
      return this.icon?.size || 24;
    },
    iconColor() {
      return this.icon?.color || '#999999';
    },
  },
  methods: {
    onClickAction() {
      this.$emit('onClickAction');
    },
  },
};
</script>

<style module lang="less" src="./vInput.less"></style>
